import React from 'react'
import './home-main.css'
import '../main_root.css'
import S1_Home from './S1_Home';
import S3_home from './S3_home';
import S4_home from './S4_home';
import S2_home from './S2_home';
import S5_home from './S5_home';
import S1_Fotter from '../fotter/S1_Fotter';
function Home_main() {
    return (
        <>
            <S1_Home />
            <S2_home/>
            <S3_home />
            <S4_home />
            <S5_home />
            <S1_Fotter/>
        </>
    )
}


export default Home_main;